import { text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
import UndoIcon from "../../icons/undo.svg?react";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import { StyledTextControl } from "../StyledControl";
import { fireUndoEvent } from "../../lib/editor/events";

function UndoControl() {
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);

  const handleClick = () => fireUndoEvent();

  const mouseOver = () => setTextHelper(text.textControls.undo);
  const mouseLeave = () => setTextHelper(undefined);

  return (
    <StyledTextControl
      $dim={false}
      onClick={handleClick}
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
      aria-label={text.textControls.undo}
      $isInPortrait={isInPortrait}
      $collapseMargin
      data-testid="undo-control"
    >
      <UndoIcon aria-hidden="true" focusable="false" className="format-text-control undo"/>
    </StyledTextControl>
  );
}

export default UndoControl;
